<template>
    <div class = "information-wrapper content-wrapper">
        <div class="header-title" style="display: flex;position: relative;">
            <span class="header-title-block"></span>
            <span class="header-title-txt">商品信息</span>
            <span class="header-title-show">
                ( 计划数：<span @dblclick="copyItem($event)">{{ formateValue(formData.totalQty)}}</span> /
                实发数：<span @dblclick="copyItem($event)">{{formateValue(formData.qtyItemLoaded)}}</span> /
                实收数：<span @dblclick="copyItem($event)">{{formateValue(formData.qtyItemSignoff)}}</span> /
                总方量：<span @dblclick="copyItem($event)">{{formateValue(formData.totalVolume)}}</span> m³ /
                总重量：<span @dblclick="copyItem($event)">{{formateValue(formData.totalGrossWeight)}}</span> KG /
                包裹数：<span @dblclick="copyItem($event)">{{formateValue(formData.sumPackages)}}</span> /
                总包件数：<span @dblclick="copyItem($event)">{{formateValue(formData.totalPkgQty)}}</span>)
            </span>
            <span style="position: absolute;right: 45px;">
                <el-button type="text" @click="openReceipt">签收详情</el-button>
            </span>
        </div>
        <el-divider></el-divider>
        <section class="table-container">
            <el-table
                border
                height="150px"
                style="width:100%"
                :data="tableData"
                @cell-dblclick="cellDblClick"
            >
                <el-table-column
                    v-for="(column, index) in tableProp"
                    :key="index"
                    :width="column.width"
                    :label="column.label"
                    :prop="column.prop"
                    :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
        </section>
    </div>
</template>

<script>
import { tableProp } from '../config.js';
import { copyToClip } from '../util.js';
export default {
    name: 'GoodsInformation',
    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        tableData: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            tableProp
        };
    },
    methods: {
        /**
         * @description 双击复制单元格信息
         */
        cellDblClick (row, column, cell, event) {
            const value = row[column.property];
            value !== '--' && copyToClip(value);
        },
        copyItem (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        },
        formateValue (value) {
            return (value === null || value === undefined || value === '') ? '--' : value;
        },
        openReceipt () {
            this.$router.push({
                path: '/otp/receipt-center',
                query: {
                    customerOrderNo: this.formData.customerOrderNo
                }
            });
        }
    }
};
</script>
